<script setup lang="ts">
definePageMeta({ layout: "search" });

const route = useRoute();

const singleSlug = computed(() => route.params.slug?.toString() || "");
</script>

<template>
  <WorkersSearchPage :single-slug="singleSlug" />
</template>
